module.exports = __webpack_public_path__ + "static/media/constitution.11637de7.jpg";